var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUgcPersuasion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-4h24v24H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#898B91",
    d: "M8 0a8.009 8.009 0 018 8 8 8 0 11-8-8zm2.933 6.667H9.267a.167.167 0 01-.139-.26l1.31-1.964a.5.5 0 00-.416-.776H7.539a.667.667 0 00-.596.368L4.82 8.278A.5.5 0 005.267 9h1.04a.167.167 0 01.158.22L5.35 12.56a.333.333 0 00.553.342l5.382-5.383a.5.5 0 00-.352-.853z"
  }))));
}
export default SvgUgcPersuasion;